import { initSlider } from './../page-slider'

const sliderContainer = document.querySelector('.landing-container')

if (sliderContainer) {
  initSlider(sliderContainer, "landing-block")
}

